import { useApiClient } from "../../../shared/customHooks";
import { ToastInfo } from "../../toaster/toaster";
import { eventEmitter } from "../../../shared/event";
import { Button } from "primereact/button";

export default function ResetMFAButtonComponent({
  userId,
  disabled,
  setDisabled,
  disabledLabel,
  hideDisabledLabel,
}: {
  userId?: string;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  disabledLabel: string;
  hideDisabledLabel: boolean;
}) {
  const { putData } = useApiClient("UserManagement", { identity: true });

  // Disable button while processing request + after success
  function handleResetMFA() {
    if (!userId) {
      console.error(`userId is invalid. Getting '${userId}'. `);
      return;
    }

    setDisabled(true);

    putData({}, `resetMFA/${userId}`)
      .then(() => {
        const toastData: ToastInfo = { title: "Success", message: "MFA Reset Successful!", severity: "success" };
        eventEmitter.emit("tstr", toastData);
      })
      .catch(() => {
        setDisabled(false);

        const toastData: ToastInfo = { title: "Error", message: "MFA Reset Unsuccessful!", severity: "error" };
        eventEmitter.emit("tstr", toastData);
      });
  }

  return (
    <>
      {disabled && !hideDisabledLabel && <p className="mt-5">{disabledLabel}</p>}
      <Button label="Reset MFA" disabled={disabled} className="save-button" onClick={handleResetMFA} />
    </>
  );
}
